<template>
  <div>
    <div v-for="(item,index) in surveyList" :key="index" v-if="surveyList.length>0" @click="toSurvey(item)">
      <Menu src="static/img/manyidudiaocha.png" :text="item.questName"></Menu>
    </div>
    <div class="noCard" v-if="!surveyList.length>0">
      <div class="noCard-img">
        <img src="static/img/noCard.png"/>
      </div>
      <div class="noCard-text">暂无数据</div>
    </div>
  </div>
</template>

<script>
  import Menu from '../common/Menu'
  import {getmanyidulist} from '../../api/index'
    export default {
      data(){
        return{
          surveyList:[]
        }
      },
      components:{
        Menu
      },
      created() {
        //修改标题
        document.title = '建议和满意度调查'
        getmanyidulist().then(res=>{
          this.surveyList = res.Data
        })
      },
      methods:{
        toSurvey(item){
          if(item.questUrl.indexOf("http") != -1){
            window.location.href = item.questUrl
          }else {
            this.$router.push({path:item.questUrl,query:{id:item.id,name:item.questName}})
          }
        }
      }
    }
</script>

<style scoped>
  .noCard{
    width: 7.5rem;
    height: 3.5rem;
    padding: 2rem 0 4rem 0;
    background-color: #ffffff;
  }
  .noCard .noCard-img{
    width: 2.6rem;
    height: 2.6rem;
    margin: 0 auto;
  }
  .noCard .noCard-img img{
    width: 100%;
    height: 100%;
  }
  .noCard .noCard-text{
    margin-top: .3rem;
    font-size: .32rem;
    line-height: .32rem;
    width: 100%;
    height: .32rem;
    text-align: center;
    color: #999999;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/satisfactionSurvey.vue